import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Switch } from '../../Components/Form';
import { usePreference } from '../../Data/Preference';

const CloseQuote = ({refresh, closeQuote, rejectQuote, isClosing, setIsClosing, go}) => {
    
    return <Modal isOpen={isClosing} setIsOpen={setIsClosing} title="Close Quote" dismissible>
        <Inner {...{closeQuote, rejectQuote, refresh, go}} />
    </Modal>
}

const Inner = ({closeQuote, rejectQuote, refresh, go}) => { 
    const [decline, setDecline] = usePreference('decline-closed-quotes', true);

    const submit = async (data) => {
        if (data.decline) {
            await rejectQuote();
        } else {
            await closeQuote();
        }

        refresh();
        go('/manage/quotes');
    }

    return <Form onSubmit={submit} data={{decline: decline}} closeModalOnSubmit>
        <Switch label="Decline quote"
            innerLabel="Mark quote as declined"
            name="decline"
            onChange={setDecline}
            help={d => d ?
                'This quote will be marked as declined so the customer can see you don\'t intend to take the job.' :
                'The quote won\'t be marked as declined.'
            }
        />
        <Actions submit={{label: 'Close quote', theme: 'danger'}} cancel />
    </Form>;
}

export default CloseQuote;